<template>
    <form
        ref="form"
        @submit.prevent="submit"
        :action="formRoute"
        method="POST"
        class="relative h-full"
    >
        <page-header
            :submit-button-text="data ? 'Update' : 'Create'"
            :show-submit-button="true"
            :submit-button-disabled="submitButtonDisabled || !editable"
            submit-button-type="submit"

            :can-delete="canDelete"
            :delete-route="deleteRoute"
            :delete-value="deleteValue"

            :can-create="canCreate"
            :create-route="createRoute"
            :create-value="createValue"

            :index-route="indexRoute"
            :index-value="indexValue"
            :title="title"
            :subtitle="subtitle"

            :show-preview-button="false"

            :errors="errors"
            :is-slide-over="isSlideOver"

            :version-id="versionId"
            :init-version-id="initVersionId"
            :last-updated-by="lastUpdatedBy"
        />

        <translator
            v-if="baseDocument"
            :base-document="baseDocument"
            :document-type="documentType"
            :language="form.language"
        ></translator>

        <input-rich-text
            name="editor_note"
            label="Editor's note"
            v-model="form.editor_note"
            :language="form.language"
            :error="errors.editor_note ? errors.editor_note[0] : null"
            :maxlength="60000"
        />
        <p class="my-1 text-xs text-gray-600 dark:text-gray-300 mb-3">The note is for internal use only and won’t be displayed on the site</p>

        <input-text
            name="name"
            label="* Name"
            v-model="form.name"
            :error="errors.name ? errors.name[0] : null"
            :maxlength="255"
        />

        <media-reference
            :language="form.language"
            v-model="form.photo"
            class="mt-3"
            label="Image"
            :media-types="['OperatorLogo']"
            name="photo_id"
        />

        <div
            class="border bg-white dark:bg-gray-700 rounded-lg w-full p-4 shadow-sm max-w-4xl mt-3"
        >
            <p class="text-gray-700 dark:text-gray-200 mb-4">Game Type</p>
            <reference
                create-text="Create new game type and link game type to this page"
                link-text="Link an existing game type"
                :language="form.language"
                v-model="form.game_type"
                model-data="Game Type"
                :should-open-new-window="true"
                :error="errors.game_type_id ? errors.game_type_id[0] : null"
                :query="{
                    exclude_slots: true,
                }"
                :creatable="false"
                :order="{
                    'name': 'asc'
                }"
            />
        </div>
        <div
            class="border bg-white dark:bg-gray-700 rounded-lg w-full p-4 shadow-sm max-w-4xl mt-3"
        >
            <p class="text-gray-700 dark:text-gray-200 mb-4">Software</p>
            <reference
                create-text="Create new software and link software to this page"
                link-text="Link an existing software"
                :language="form.language"
                v-model="form.software"
                model-data="Software"
                :should-open-new-window="true"
                :creatable="false"
                :order="{
                    'name': 'asc'
                }"
            />
        </div>

        <input-date
            label="Launch Date"
            name="launch_date"
            v-model="form.launch_date"
            class="block max-w-4xl mt-3"
            :error="errors.launch_date ? errors.launch_date[0] : null"
        />

        <input-text
            name="rtp_percentage"
            label="% RTP"
            type="number"
            :step="0.01"
            class="mt-3"
            v-model="form.rtp_percentage"
            :error="errors.rtp_percentage ? errors.rtp_percentage[0] : null"
        />

        <input-text
            name="min_bet"
            label="Min Bet"
            type="number"
            :step="0.01"
            class="mt-3"
            v-model="form.min_bet"
            :error="errors.min_bet ? errors.min_bet[0] : null"
        />

        <input-text
            name="max_bet"
            label="Max Bet"
            type="number"
            :step="0.01"
            class="mt-3"
            v-model="form.max_bet"
            :error="errors.max_bet ? errors.max_bet[0] : null"
        />

        <input-checkbox
            name="has_autoplay"
            label="Has Autoplay"
            class="mt-3"
            v-model="form.has_autoplay"
            :error="errors.has_autoplay ? errors.has_autoplay[0] : null"
        />

        <input type="hidden" name="_token" :value="csrf" />
        <input v-if="data" type="hidden" name="_method" value="patch" />
    </form>
</template>

<script>
import crudForm from "../mixins/crudForm";

export default {
    mixins: [crudForm],
    name: "GameForm",
    data() {
        return {
            form: {
                editor_note: this.getFormData("editor_note"),
                name: this.getFormData("name"),
                photo_id: this.getFormData("photo_id"),
                photo: this.getFormData("photo"),
                game_type: this.getFormData("game_type"),
                game_type_id: this.getFormData("game_type_id"),
                software: this.getFormData("software"),
                software_id: this.getFormData("software_id"),
                launch_date: this.getFormData("launch_date"),
                rtp_percentage: this.getFormData("rtp_percentage"),
                min_bet: this.getFormData("min_bet"),
                max_bet: this.getFormData("max_bet"),
                has_autoplay: !!this.getFormData("has_autoplay") || false,
            },
        };
    },
    watch: {
        "form.photo": function(newValue){
            this.form.photo_id = newValue ? newValue.id : null;
        },
        "form.game_type": function (newValue) {
            if(!newValue) return;
            this.form.game_type_id = newValue.id;
        },
        "form.software": function (newValue) {
            if(!newValue) return;
            this.form.software_id = newValue.id;
        },
    },
};
</script>
